import isNil from 'lodash/isNil';

import { BackendMessagesDE, BackendMessagesEN, BackendMessagesFR, BackendMessagesNL } from './i18n/backendMessages';
import { deCountriesLocale, enCountriesLocale, frCountriesLocale, nlCountriesLocale } from './i18n/countries';
import reportingDE from './i18n/de/messages/accounting/reporting.json';
import reportingEN from './i18n/en/messages/accounting/reporting.json';
import reportingFR from './i18n/fr/messages/accounting/reporting.json';
import { MessagesDE, MessagesEN, MessagesFR, MessagesNL } from './i18n/messages';
import reportingNL from './i18n/nl/messages/accounting/reporting.json';
import { Language } from './types';

const toLanguageKey = (language?: Language | string | null): Language => {
  if (isNil(language)) {
    return Language.EN;
  }
  return language.toUpperCase() as Language;
};

export const getLocalizedMessages = (language?: Language | string | null) => {
  const languageMessages = {
    [Language.FR]: MessagesFR,
    [Language.NL]: MessagesNL,
    [Language.DE]: MessagesDE,
    [Language.EN]: MessagesEN,
  };
  return languageMessages[toLanguageKey(language)] ?? MessagesEN;
};

export const getLocalizedBackendMessages = (language?: Language | string | null) => {
  const languageMessages = {
    [Language.FR]: BackendMessagesFR,
    [Language.NL]: BackendMessagesNL,
    [Language.DE]: BackendMessagesDE,
    [Language.EN]: BackendMessagesEN,
  };
  return languageMessages[toLanguageKey(language)] ?? BackendMessagesEN;
};

export const getLocalizedCountries = (language?: Language | string | null) => {
  const languageCountries = {
    [Language.FR]: frCountriesLocale,
    [Language.NL]: nlCountriesLocale,
    [Language.DE]: deCountriesLocale,
    [Language.EN]: enCountriesLocale,
  };
  return languageCountries[toLanguageKey(language)] ?? enCountriesLocale;
};

export const getLocalizedReportingMessages = (language?: Language | string | null) => {
  const languageMessages = {
    [Language.FR]: reportingFR,
    [Language.NL]: reportingNL,
    [Language.DE]: reportingDE,
    [Language.EN]: reportingEN,
  };
  return languageMessages[toLanguageKey(language)] ?? reportingEN;
};
